import { AnyAction } from 'redux';
import { opApiRequest } from 'src/api/apiRequest';
import endpoints from 'src/api/opEndpoints';
import getAbstractProduct from 'src/store/design/selector/getAbstractProduct';
import getCategoryId from 'src/store/design/selector/getCategoryId';
import getDesignId from 'src/store/design/selector/getDesignId';
import getEncPublicDesignId from 'src/store/design/selector/getEncPublicDesignId';
import getProductId from 'src/store/design/selector/getProductId';
import getStructure from 'src/store/design/selector/getStructure';
import isPublicDesign from 'src/store/design/selector/isPublicDesign';
import { Store } from 'src/store/index';
import { ThunkDispatch } from 'redux-thunk';
import ensureCorrectProductUid from 'src/util/design/ensureCorrectProductUid';
import getDesignContentHash from 'src/util/design/getDesignContentHash';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';

const updateCustomerDesignOperation = () => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const store = getState();

  if (isPublicDesign(store)) {
    return false;
  }

  const {
    clientPlatform,
  } = useIntegrationLayer();

  const structure = getStructure(store);
  const designId = getDesignId(store);
  const categoryId = getCategoryId(store);
  const encPublicDesignId = getEncPublicDesignId(store);
  const productId = getProductId(store);
  const abstractProduct = getAbstractProduct(store);

  if (!structure || !designId || !categoryId) {
    return false;
  }

  // Ensure the correct product_uid is set based on populated spreads
  const structureToSave = ensureCorrectProductUid(structure);

  const contentHash = getDesignContentHash(structureToSave);

  const requestData = {
    customerDesignId: designId,
    categoryId,
    structure: structureToSave,
    clientPlatform,
    isDesignCompleted: true,
    contentHash,
    encPublicDesignId,
    productId: abstractProduct
      ? (abstractProduct.products?.find((p) => p.productUid === structureToSave.product_uid)?.productId ?? productId)
      : null,
  };

  try {
    await opApiRequest(
      endpoints.CUSTOMER_DESIGN_V3_UPDATE,
      requestData,
      'data',
      'POST',
    );
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Cannot update customer design', e);
    return false;
  }
};

export default updateCustomerDesignOperation;
